import ApiService from "../../helpers/ApiHelper";

class ParentService {

    static getParents({type, search='', q='', page = 1, pageSize = 20}) {
        // Build query parameters
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('pageSize', pageSize);
        if (search) {
            params.append('search', search);
        }
        if (q) {
            params.append('q', q);
        }

        // Build URL - use /role/:role endpoint when type is provided, otherwise /users endpoint
        const url = type 
            ? `/api/v1/users/role/${type}?${params.toString()}`
            : `/api/v1/users/?${params.toString()}`;
        
        return ApiService.request(url, "get", {});
    }

    static addParent(payload) {
        return ApiService.request(
            "/api/v1/users/",
            "post",
            payload
        )
    }

    static removeParent(id) {
        return ApiService.request(
            `/api/v1/users/${id}`,
            "delete",
            null
        )
    }

    static editParent(parent){
        return ApiService.request(
            `/api/v1/users/${parent.id}`,
            "patch",
            parent
        )
    }
}

export default ParentService;
